var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: -166.2,
  y: -953.5,
  fill: "none",
  width: 612,
  height: 1330
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: -166.2,
  y: -953.5,
  fill: "none",
  width: 612,
  height: 1330
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: -166.2,
  y: -953.5,
  fill: "none",
  width: 612,
  height: 1330
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: -166.2,
  y: -953.5,
  fill: "none",
  width: 612,
  height: 1330
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: -166.2,
  y: -953.5,
  fill: "none",
  width: 612,
  height: 1330
});

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M11.1,37.5h22.7c0.7,0,1.3-0.6,1.3-1.3v-1c0-0.6-0.4-1.1-1-1.2v-9.7c0.6-0.2,1-0.7,1-1.3v-1 c0-0.6-0.4-1.1-1-1.3V11c0.6-0.1,1-0.6,1-1.2v-1c0-0.7-0.6-1.3-1.3-1.3H11.1c-0.7,0-1.3,0.6-1.3,1.3v1c0,0.6,0.4,1.1,1,1.2v9.7 c-0.6,0.2-1,0.7-1,1.3v1c0,0.6,0.4,1.1,1,1.3V34c-0.6,0.1-1,0.6-1,1.2v1C9.9,36.9,10.4,37.5,11.1,37.5z M10.6,9.9V8.8 c0-0.3,0.2-0.5,0.5-0.5h22.8c0.3,0,0.5,0.2,0.5,0.5v1.1c0,0.3-0.2,0.5-0.5,0.5H11.1C10.9,10.4,10.6,10.1,10.6,9.9z M11.6,11.1h21.7 v9.7H11.6V11.1z M10.6,23.1V22c0-0.3,0.2-0.5,0.5-0.5h22.8c0.3,0,0.5,0.2,0.5,0.5v1.1c0,0.3-0.2,0.5-0.5,0.5H11.1 C10.9,23.6,10.6,23.3,10.6,23.1z M11.6,24.3h21.7V34H11.6V24.3z M10.6,35.2c0-0.3,0.2-0.5,0.5-0.5h22.8c0.3,0,0.5,0.2,0.5,0.5v1.1 c0,0.3-0.2,0.5-0.5,0.5H11.1c-0.3,0-0.5-0.2-0.5-0.5V35.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M33.3,20.8v-9.7H11.6v9.7H33.3z M18.9,13.2h7.2c0.7,0,1.3,0.6,1.3,1.3v1c0,0.7-0.6,1.3-1.3,1.3h-7.2 c-0.7,0-1.3-0.6-1.3-1.3v-1C17.6,13.8,18.2,13.2,18.9,13.2z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 11.6,
  y: 24.3,
  fill: "#F9F9F9",
  width: 21.7,
  height: 9.7
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M33.9,10.4c0.3,0,0.5-0.2,0.5-0.5V8.8c0-0.3-0.2-0.5-0.5-0.5H11.1c-0.3,0-0.5,0.2-0.5,0.5v1.1 c0,0.3,0.2,0.5,0.5,0.5H33.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M11.1,36.8h22.8c0.3,0,0.5-0.2,0.5-0.5v-1.1c0-0.3-0.2-0.5-0.5-0.5H11.1c-0.3,0-0.5,0.2-0.5,0.5v1.1 C10.6,36.5,10.9,36.8,11.1,36.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M33.9,23.6c0.3,0,0.5-0.2,0.5-0.5V22c0-0.3-0.2-0.5-0.5-0.5H11.1c-0.3,0-0.5,0.2-0.5,0.5v1.1 c0,0.3,0.2,0.5,0.5,0.5H33.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M17.6,15.5c0,0.7,0.6,1.3,1.3,1.3h7.2c0.7,0,1.3-0.6,1.3-1.3v-1c0-0.7-0.6-1.3-1.3-1.3h-7.2 c-0.7,0-1.3,0.6-1.3,1.3V15.5z"
}));

function SvgKeg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeg);
export default __webpack_public_path__ + "static/media/keg.d17483c6f14f1b591b28e9f8f7b99ff4.svg";
export { ForwardRef as ReactComponent };